<section id="products" class="section-padding bg-white relative">
  <!-- Decorative Elements -->
  <div class="absolute top-0 left-0 w-64 h-64 bg-mint/5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
  <div class="absolute bottom-0 right-0 w-96 h-96 bg-peach/5 rounded-full translate-x-1/3 translate-y-1/3"></div>

  <div class="container mx-auto px-4 md:px-6 relative z-10">
    <div class="max-w-xl mx-auto text-center mb-16 appear-on-scroll opacity-0">
      <span class="subtitle mb-3">Featured Products</span>
      <h2 class="heading-lg mb-6">Experience Ancient Wisdom</h2>
      <p class="body-md text-forest/80 max-w-lg mx-auto">
        Our premium selection of organic herbs and supplements, thoughtfully crafted to enhance your wellness journey.
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
      <div *ngFor="let product of products; let i = index"
           class="appear-on-scroll opacity-0 product-card-hover rounded-xl overflow-hidden bg-white border border-mint/20 shadow-sm"
           [style.animationDelay]="i * 150 + 'ms'">
        <div class="aspect-square overflow-hidden relative group" >
          <img [src]="product.imageUrl" [alt]="product.name"
               class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />

          <div class="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-6">

            @if (product.inStock && product.stock > 0) {
              <button (click)="onAddToCart(product)" class="button-primary flex items-center gap-2 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path d="M3 3h2l.4 2M7 13h14l-1.5 6H6.5L5 6h16M7 13L5 6m2 7l1.5 6m10.5-6l1.5 6M10 10a1 1 0 100-2 1 1 0 000 2z" />
                </svg>
                <span>Add to Cart</span>
              </button>
            }
            @else {
              <button  class="p-2 bg-red-500 text-white rounded-lg flex items-center gap-2 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path d="M3 3h2l.4 2M7 13h14l-1.5 6H6.5L5 6h16M7 13L5 6m2 7l1.5 6m10.5-6l1.5 6M10 10a1 1 0 100-2 1 1 0 000 2z" />
                </svg>
                <span>Out Of Stock</span>
              </button>
            }


          </div>
        </div>
        <div class="p-5 cursor-pointer" (click)="onProductClick(product)">
          <div class="text-sm text-mint-dark font-medium mb-1">{{ product.category?.name }}</div>
          <h3 class="font-cormorant text-xl font-semibold mb-2">{{ product.name }}</h3>
          <div class="flex items-center justify-between">
            <div>
              <span class="text-lg text-red-600">{{ discountCalculator(product) }}</span>
              <span class="text-2xl font-semibold text-forest mr-1">  ₹{{ product.price }}</span>
              <span class="text-sm font-semibold text-forest line-through text-gray-500" *ngIf="product.retailPrice > 0 " >₹{{ product.retailPrice }}</span>
            </div>
            <div class="flex items-center gap-1" *ngIf="calcRating(product)">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-yellow-500 fill-current" viewBox="0 0 24 24">
                <path d="M12 .587l3.668 7.431L24 9.748l-6 5.851L19.335 24 12 19.897 4.665 24 6 15.599 0 9.748l8.332-1.73z"/>
              </svg>
              <span class="text-sm font-medium">{{ calcRating(product) }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- <div *ngFor="let product of products; let i = index"
           class="appear-on-scroll opacity-0 product-card-hover rounded-xl overflow-hidden bg-white border border-mint/20 shadow-sm"
           [style.animationDelay]="i * 150 + 'ms'">
        <div class="aspect-square overflow-hidden relative group">
          <img [src]="product.image" [alt]="product.name"
               class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <div class="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-6">
            <button class="button-primary flex items-center gap-2 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path d="M3 3h2l.4 2M7 13h14l-1.5 6H6.5L5 6h16M7 13L5 6m2 7l1.5 6m10.5-6l1.5 6M10 10a1 1 0 100-2 1 1 0 000 2z" />
              </svg>
              <span>Add to Cart</span>
            </button>
          </div>
        </div>
        <div class="p-5">
          <div class="text-sm text-mint-dark font-medium mb-1">{{ product.category }}</div>
          <h3 class="font-cormorant text-xl font-semibold mb-2">{{ product.name }}</h3>
          <div class="flex items-center justify-between">
            <span class="text-lg font-semibold text-forest">${{ product.price }}</span>
            <div class="flex items-center gap-1">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-yellow-500 fill-current" viewBox="0 0 24 24">
                <path d="M12 .587l3.668 7.431L24 9.748l-6 5.851L19.335 24 12 19.897 4.665 24 6 15.599 0 9.748l8.332-1.73z"/>
              </svg>
              <span class="text-sm font-medium">{{ product.rating }}</span>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <div class="mt-12 md:mt-16 text-center appear-on-scroll opacity-0">
      <a routerLink="/shop" class="button-secondary">View All Products</a>
    </div>
  </div>
</section>
